import React from 'react';
import './Footer.css';

import { Logo, Newsletter } from '../../components'; // Importing the Logo and Newsletter components
import { contactContent } from '../../constants'; // Importing contact information and services data

// Importing necessary icons from react-icons
import { FaFacebookF, FaInstagram, FaLinkedin, FaShieldAlt } from 'react-icons/fa';
import { FaXTwitter } from "react-icons/fa6";

// Importing Link for navigation
import { Link } from 'react-router-dom'; 



const Footer = () => {

  return (
    <footer className='footer'>

      <div className='box-container'>

        {/* About Section */}
        <div className='footer-item'>

          <Logo /> {/* Logo component */}
          <p>Providing top-notch security solutions to keep your premises safe and secure. Our state-of-the-art systems ensure round-the-clock surveillance, advanced motion detection, and real-time alerts, giving you peace of mind.</p> {/* Description for the about section */}

          {/* Social media icons with links */}
          <div className='social'>
            <a href="/#"><FaFacebookF className='icon' /></a>
            <a href="/#"><FaXTwitter className='icon' /></a>
            <a href="/#"><FaInstagram className='icon' /></a>
            <a href="/#"><FaLinkedin className='icon' /></a>
          </div>

        </div>

        {/* Useful Links Section */}
        <div className='footer-item'> 

          <h2>Quick Links</h2>

          {/* Links for easy navigation to various pages */}
          <div className='info links'> 
            <p><FaShieldAlt className='icon' /><Link to='/About-us'>About Us</Link></p>
            <p><FaShieldAlt className='icon' /><Link to='/Services'>Services</Link></p>
            <p><FaShieldAlt className='icon' /><Link to='/CaseStudies'>Case Studies</Link></p>
            <p><FaShieldAlt className='icon' /><Link to='/Blog-grid'>Blogs</Link></p>
            <p><FaShieldAlt className='icon' /><Link to='/Shop-list'>Shop</Link></p>
            <p><FaShieldAlt className='icon' /><Link to='/Contact-us'>Contact Us</Link></p>
          </div>

        </div>

        {/* Contact Info Section */}
        <div className='footer-item'>

          <h2>Contact Info</h2>

          <div className='info connect'>

            {contactContent
            .filter(contact => contact.id !== 4) // Exclude the contact with id: 4
            .map((contact) => (
                contact.content.map((value, index) => (
                  <div key={index} className='connect-item'>
                    <div className='icon'>{contact.icon}</div>
                    <span>{value}</span>
                  </div>
                ))
            ))}
          </div>

        </div>

        {/* Newsletter Section */}
        <div className='footer-item'> 

          <h2>Stay Updated</h2>
          <p>Subscribe to receive the latest updates on security systems directly in your inbox.</p> {/* Description for the about section */}

          {/* Newsletter component to subscribe */}
          <Newsletter variant='dark' idPrefix='2' />

        </div>

      </div>

      <div className='content'>

        {/* Footer content with copyright information */}
        <p>&copy; Secura 2024 All Rights Reserved</p>

        {/* Terms of Services & Privacy Policy Links */}
        <p>
          <Link to='/Services-Terms'>Terms of services</Link> | <Link to='/Privacy-Policy'> Privacy Policy</Link>
        </p>

      </div>

    </footer>
  )
}

export default Footer;